(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxExtraWizard', {
		bindings: {
			isActive: '=',
			wizardContext: '<?',
			wizardWidgetId: '@',
			mainWizard: '=',
			selectedObjects: '=',
			typeName: '@',
			positionInMainWizard: '@',
		},
		template: '<div mx-view="vm.nonVisuals" />',
		controller: MxExtraWizardCtrl,
		controllerAs: 'vm',
	});

	MxExtraWizardCtrl.$inject = ['$scope', '$q', 'mx.SolutionBuilderAgent.WizardService', 'mx.shell.View'];

	function MxExtraWizardCtrl($scope, $q, mxWizardService, View) {
		var vm = this;
		var _thisExtraWizard;
		var freeDataSourceDefer = $q.defer();

		$scope.$watchGroup(['vm.isActive', 'vm.mainWizard', 'vm.wizardContext'], handleExtraWizardActivation);

		vm.$onDestroy = function () {
			freeDataSourceDefer.resolve(true);
		};

		return vm;

		function handleExtraWizardActivation() {
			if (!vm.mainWizard) {
				return;
			}

			if (vm.isActive) {
				// Init extra wizard
				mxWizardService
					.getWizardAndDataModel(
						vm.typeName, // TypeName
						mx.SolutionBuilderAgent.WizardMode.Default,
						vm.wizardWidgetId, // WidgetId
						undefined, // WizardView
						undefined, // ActionId
						undefined, // ActionName
						undefined, // FinishTitle
						undefined, // CustomHeader
						vm.selectedObjects, // SelectedObjects
						vm.wizardContext, // OuterContext
						vm.mainWizard, // MainWizardRef,
						freeDataSourceDefer.promise // FreeDataSourcePromise
					)
					.then(function (res) {
						if (vm.isActive) {
							_thisExtraWizard = res.wizard;
							_thisExtraWizard.positionInBaseWizard = parseInt(vm.positionInMainWizard) || 0;

							// Remove inner extra wizards
							var template = res.nonVisualTemplate;
							template = vm.mainWizard ? template.replace(/<mx-extra-wizard.+?<\/mx-extra-wizard>/gi, '') : template;

							vm.nonVisuals = new View({
								template: template,
								id: 'nvc_' + _thisExtraWizard.id,
								controller: angular.noop,
								locals: res,
							});

							vm.mainWizard.addExtraWizard(_thisExtraWizard, true);
						}
					});
			} else {
				vm.mainWizard.removeExtraWizard(_thisExtraWizard);
			}
		}
	}
})();
